import { useState, useRef, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import {
  // ButtonSecondary,
  // IconDownload,
  // IconUpload,
  // ButtonSize,
  Table,
  Dropzone,
  IconDropzone,
  useQueryState,
  PermissionEnum,
  useGetList,
  Country,
  useFilters,
  usePrevious,
} from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import { onFileUpload } from './store/slices/geographical';
import {
  geographicalRiskColumns,
  geographicalRiskSchema,
  geographicalRiskFiltersSchema,
} from './variables/geographical';
import { useLazyGetAmlCountriesQuery } from './store/services';

import cn from './geographical.module.css';

const GeographicalRisk = () => {
  const [dropzoneVisible, setDropzoneVisible] = useState(false);

  const { uploadInProgress, uploadSuccess, values, pagination, errorsList } =
    useAppSelector((state) => state.geographical);

  const { activePermissions } = useAppSelector(
    (state) => state.amlDictionaries,
  );

  const [getAmlCountries, { isLoading, isFetching }] =
    useLazyGetAmlCountriesQuery();

  const inputRef = useRef<HTMLInputElement | null>(null);

  const dispatch = useAppDispatch();
  const { sort, onFilterChange, filters } = useQueryState(
    geographicalRiskSchema,
  );

  const prevFilters = usePrevious(filters);

  const { getListAction, setPage, onFilter, errorList } = useGetList<Country>({
    getList: getAmlCountries,
    onFilterChange,
    onSortChange: () => {},
    schema: geographicalRiskSchema,
  });

  const { filtersComponent, handleSubmit: geographicalSubmit } = useFilters({
    filtersSchema: geographicalRiskFiltersSchema,
    filters,
    onFilterChange: onFilter,
  });

  const onUpload = (data: FileList) => {
    const file = data[0];

    dispatch(onFileUpload(file));

    if (inputRef?.current) {
      inputRef.current.value = '';
    }
  };

  useEffect(() => {
    if (prevFilters && !Object.keys(prevFilters).length && filters && !values) {
      getListAction({
        filters,
      });
    }
  }, [filters, prevFilters, values]);

  useEffect(() => {
    if (uploadSuccess) {
      setDropzoneVisible(false);
    }
  }, [uploadSuccess]);

  let content: React.JSX.Element;

  if (
    dropzoneVisible &&
    activePermissions?.includes(PermissionEnum.AML_GEO_EDIT_SETTINGS_ACTION)
  ) {
    content = (
      <div className={cn.geographicalDropzoneWrapper}>
        <Dropzone
          inputRef={inputRef}
          onUpload={onUpload}
          // accept=".csv, text/xml"
          dropzoneIcon={<IconDropzone />}
          fileUploadInProgress={uploadInProgress}
          dropzoneText="Drag your CSV or XML file here"
          dropzoneClassName={cn.dropzone}
        />
      </div>
    );
  } else {
    content = (
      <Table
        columns={geographicalRiskColumns}
        data={values || []}
        onSort={() => {}}
        tableClassName={cn.geographicalTable}
        isLoading={isLoading || isFetching}
        filters={filters}
        sort={sort}
        pagination={pagination}
        take="30"
        setPage={(data) => setPage({ ...data, filters })}
        onFilterChange={(filtersValues) => onFilter(filtersValues)}
        filtersComponent={filtersComponent}
        handleSubmit={geographicalSubmit}
        columnsLabels={{}}
        tableFormClassName={cn.geographicalRiskTableForm}
        error={errorsList || errorList}
        clickable
      />
    );
  }

  return (
    <>
      <div className={cn.geographicalRiskControls}>
        {/* {values && (
          <>
            {activePermissions?.includes(
              PermissionEnum.AML_GEO_EDIT_SETTINGS_ACTION,
            ) && (
              <ButtonSecondary
                size={ButtonSize.SMALL}
                className={`button-white ${cn.geographicalRiskControlButton}`}
                text={dropzoneVisible ? 'Show list' : 'Upload list file'}
                icon={<IconUpload />}
                onClick={() => setDropzoneVisible(!dropzoneVisible)}
              />
            )}

            <ButtonSecondary
              size={ButtonSize.SMALL}
              className={`button-white ${cn.geographicalListRiskControlButton}`}
              text="Download list"
              icon={<IconDownload />}
            />
          </>
        )} */}
      </div>
      {content}
      <Outlet />
    </>
  );
};

export default GeographicalRisk;
